export default __webpack_public_path__ + "static/media/hht1_ep20_minisitcom_03.602041f5.png";